"use client"

import { Component } from 'react'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    // Update state to indicate an error has occurred
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    // You can log the error to an error reporting service
    if (process.env.NODE_ENV !== 'production') {
      console.error('Error caught by ErrorBoundary:', error, errorInfo)
    }
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="p-6 bg-red-50 border border-red-200 rounded-lg my-4">
          <h2 className="text-lg font-semibold text-red-800 mb-2">Une erreur est survenue</h2>
          <p className="text-red-700 mb-4">
            Nous nous excusons pour ce problème. Veuillez actualiser la page ou réessayer plus tard.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="bg-red-600 hover:bg-red-700 text-white font-medium py-2 px-4 rounded transition-colors"
          >
            Actualiser la page
          </button>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary 